import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, Heart, ArrowRight } from 'lucide-react';
import FavouriteButton from '@/components/showcase/FavouriteButton';

export const CATEGORY_LABELS = {
  gt: 'GT',
  formula: 'Formula',
  rally: 'Rally',
  drift: 'Drift',
  other: 'Other',
};

export default function RigCard({ rig, index = 0 }) {
  const [imgError, setImgError] = useState(false);
  const rating = Number(rig.overall_rating || 0);
  const showStars = rating > 0;

  return (
    <Link
      to={`/simulators/${rig.slug}`}
      className="group relative block bg-[#111115] border border-white/5 hover:border-primary/40 transition-all duration-300 overflow-hidden"
    >
      {/* Image */}
      <div className="aspect-[4/3] overflow-hidden bg-[#0d0d0f] relative">
        {rig.hero_image_url && !imgError ? (
          <img
            src={rig.hero_image_url}
            alt={rig.name}
            width={400}
            height={300}
            loading="lazy"
            onError={() => setImgError(true)}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full carbon-bg" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#111115] via-transparent to-transparent" />

        {/* Top row */}
        <div className="absolute top-3 left-3 right-3 flex items-start justify-between">
          <span className="bg-black/60 backdrop-blur-sm border border-white/10 text-white/80 text-[10px] font-bold tracking-widest px-2.5 py-1">
            {CATEGORY_LABELS[rig.category] || rig.category}
          </span>
          <div onClick={(e) => e.preventDefault()}>
            <FavouriteButton rigId={rig.id} />
          </div>
        </div>

        {rig.featured && (
          <div className="absolute bottom-3 left-3 bg-primary text-white text-[9px] font-black tracking-widest px-2 py-1">
            FEATURED
          </div>
        )}
      </div>

      {/* Body */}
      <div className="p-5">
        <div className="flex items-start justify-between gap-2 mb-1.5">
          <h3 className="text-white font-bold text-base leading-tight group-hover:text-primary transition-colors">
            {rig.name}
          </h3>
        </div>
        <p className="text-white/40 text-xs leading-relaxed mb-4 line-clamp-2">{rig.short_description}</p>

        <div className="flex items-center justify-between">
          {showStars ? (
            <div className="flex items-center gap-1.5">
              <Star className="w-4 h-4 text-primary fill-primary" />
              <span className="text-white font-bold text-sm">{rating.toFixed(1)}</span>
              <span className="text-white/30 text-xs">/10</span>
            </div>
          ) : (
            <span />
          )}
          <span className="inline-flex items-center gap-1.5 text-white/40 group-hover:text-primary text-xs font-bold tracking-wider transition-colors">
            VIEW RIG <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-400 origin-left" />
    </Link>
  );
}